(() => {
  if (window.milanisCatalogQuickLoaded) return;
  window.milanisCatalogQuickLoaded = true;
  let activeDialog, opener, request, scrollBefore;
  function enable(root = document) {
    root.querySelectorAll('.mvc__card .mvc__control').forEach(button => { button.hidden = false; });
  }
  function photos(gallery) {
    return [...(gallery.querySelector('template[data-images]')?.content.querySelectorAll('[data-src]') || [])];
  }
  const galleries = new WeakMap();
  const imageCache = new Map();
  function prepareImage(source) {
    const url = new URL(source, location.href).href;
    if (!imageCache.has(url)) {
      const image = new Image();
      image.src = url;
      const promise = image.decode().then(() => image).catch(error => { imageCache.delete(url); throw error; });
      imageCache.set(url, promise);
      if (imageCache.size > 40) imageCache.delete(imageCache.keys().next().value);
    }
    return imageCache.get(url);
  }
  function warm(gallery) {
    if (!gallery || navigator.connection?.saveData) return;
    const list = photos(gallery), img = gallery.querySelector('img');
    if (list.length < 2 || !img) return;
    const index = Math.max(0, list.findIndex(item => imageKey(item.dataset.src) === imageKey(img.src)));
    for (const offset of [1, -1, 2]) {
      const next = list[(index + offset + list.length) % list.length];
      if (imageKey(next.dataset.src) !== imageKey(img.src)) prepareImage(next.dataset.src).catch(() => {});
    }
  }
  for (const eventName of ['pointerover', 'focusin', 'touchstart']) {
    document.addEventListener(eventName, event => {
      warm(event.target.closest('milanis-catalog [data-gallery]'));
    }, { passive: true });
  }
  function imageKey(source) {
    try { const url = new URL(source, location.href); return url.origin + url.pathname; }
    catch { return source; }
  }
  async function step(gallery, direction) {
    const list = photos(gallery), img = gallery.querySelector('img');
    if (list.length < 2 || !img) return;
    let state = galleries.get(gallery);
    if (!state) { state = { busy: false, queue: [] }; galleries.set(gallery, state); }
    if (state.busy) { if (state.queue.length < 5) state.queue.push(direction); return; }
    state.busy = true;
    let overlay;
    try {
      let index = list.findIndex(item => imageKey(item.dataset.src) === imageKey(img.src));
      if (index < 0) index = 0;
      const next = list[(index + direction + list.length) % list.length];
      const before = img.src;
      const loaded = (await prepareImage(next.dataset.src)).cloneNode();
      if (!gallery.isConnected || img.src !== before) return;
      overlay = loaded;
      overlay.alt = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'mvc__gallery-transition';
      const host = gallery.querySelector('.mvc__photo') || gallery;
      Object.assign(overlay.style, { position:'absolute', inset:'0', width:'100%', height:'100%', objectFit:'cover', pointerEvents:'none', zIndex:'0' });
      host.append(overlay);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        await overlay.animate([{opacity:0},{opacity:1}], {duration:140,easing:'ease-out',fill:'both'}).finished;
      }
      img.removeAttribute('srcset');
      img.src = next.dataset.src;
      img.alt = next.dataset.alt || '';
      await img.decode().catch(() => {});
      warm(gallery);
    } catch {
      // Keep the current photo if the next image cannot be loaded.
    } finally {
      overlay?.remove();
      state.busy = false;
      if (state.queue.length && gallery.isConnected) step(gallery, state.queue.shift());
    }
  }
  function variant(form) {
    const option = form.querySelector('select').selectedOptions[0];
    const content = form.closest('[data-quick-content]');
    content.querySelector('[data-quick-price]').textContent = option.dataset.price;
    const quantity = Number(option.dataset.min) || 1;
    form.elements.quantity.value = quantity;
    const note = form.querySelector('[data-quantity-note]');
    note.hidden = quantity === 1;
    note.textContent = `Quantity: ${quantity}`;
    const button = form.querySelector('[type="submit"]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
    const img = content.querySelector('.mvcq__gallery img');
    if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
  }
  async function open(button) {
    const catalog = button.closest('milanis-catalog');
    const dialog = catalog.querySelector('dialog');
    if (activeDialog?.open) return;
    opener = button;
    activeDialog = dialog;
    const body = dialog.querySelector('.mvc__dialog-body');
    body.innerHTML = '<p class="mvc__loading" role="status">Loading…</p>';
    scrollBefore = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('.mvc__close').focus();
    request?.abort();
    const pending = new AbortController();
    request = pending;
    dialog.addEventListener('close', () => {
      pending.abort();
      document.documentElement.style.overflow = scrollBefore;
      activeDialog = null;
      if (opener?.isConnected) opener.focus();
    }, { once: true });
    try {
      const url = new URL(button.dataset.quickUrl, location.origin);
      url.searchParams.set('section_id', 'milanis-quick-view');
      const response = await fetch(url, { signal: pending.signal });
      if (!response.ok) throw new Error('Could not load product');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-quick-content]');
      if (!content) throw new Error('Quick view section is missing');
      if (!dialog.open || pending.signal.aborted) return;
      body.replaceChildren(content);
      const form = body.querySelector('[data-quick-form]');
      if (form) variant(form);
      warm(body.querySelector('[data-gallery]'));
    } catch (error) {
      if (error.name === 'AbortError') return;
      body.innerHTML = '<p class="mvc__loading">Unable to load quick view. <a>Open product</a></p>';
      body.querySelector('a').href = button.dataset.quickUrl;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (button?.closest('milanis-catalog')) {
      if (button.matches('[data-step]')) step(button.closest('[data-gallery]'), Number(button.dataset.step));
      if (button.matches('[data-quick-url]')) open(button);
      if (button.matches('.mvc__close')) button.closest('dialog').close();
    }
    if (event.target === activeDialog) {
      const box = activeDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) activeDialog.close();
    }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-quick-form]');
    if (form && event.target.matches('select')) {
      variant(form);
      form.querySelector('[data-quick-status]').textContent = '';
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-quick-form]')) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    form.dataset.busy = 'true';
    const button = form.querySelector('[type="submit"]');
    const select = form.querySelector('select');
    const payload = new FormData(form);
    button.disabled = true; select.disabled = true;
    const status = form.querySelector('[data-quick-status]');
    status.textContent = 'Adding…';
    try {
      const response = await fetch(`${form.action}.js`, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item.');
      status.textContent = 'Added to your cart.';
      form.querySelector('.mvcq__cart').hidden = false;
      document.dispatchEvent(new CustomEvent('milanis:cart-added', { detail: result }));
    } catch (error) {
      status.textContent = error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message;
    } finally {
      delete form.dataset.busy;
      select.disabled = false;
      variant(form);
    }
  });
  let touch;
  document.addEventListener('touchstart', event => {
    const gallery = event.target.closest('milanis-catalog [data-gallery]');
    touch = gallery && !event.target.closest('button') ? { gallery, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', event => {
    if (!touch) return;
    const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      step(touch.gallery, dx < 0 ? 1 : -1);
      const gallery = touch.gallery;
      const suppress = e => { e.preventDefault(); e.stopPropagation(); };
      gallery.addEventListener('click', suppress, { capture: true, once: true });
      setTimeout(() => gallery.removeEventListener('click', suppress, true), 400);
    }
    touch = null;
  }, { passive: true });
  document.addEventListener('shopify:section:load', event => enable(event.target));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches('milanis-catalog, .mvc__card') || node.querySelector('milanis-catalog, .mvc__card'))) enable(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => { if (activeDialog && event.target.contains(activeDialog)) activeDialog.close(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enable());
  else enable();
})();
(() => {
  if (window.milanisCatalogQuickLoaded) return;
  window.milanisCatalogQuickLoaded = true;
  let activeDialog, opener, request, scrollBefore;
  function enable(root = document) {
    root.querySelectorAll('.mvc__card .mvc__control').forEach(button => { button.hidden = false; });
  }
  function photos(gallery) {
    return [...(gallery.querySelector('template[data-images]')?.content.querySelectorAll('[data-src]') || [])];
  }
  const galleries = new WeakMap();
  const imageCache = new Map();
  function prepareImage(source) {
    const url = new URL(source, location.href).href;
    if (!imageCache.has(url)) {
      const image = new Image();
      image.src = url;
      const promise = image.decode().then(() => image).catch(error => { imageCache.delete(url); throw error; });
      imageCache.set(url, promise);
      if (imageCache.size > 40) imageCache.delete(imageCache.keys().next().value);
    }
    return imageCache.get(url);
  }
  function warm(gallery) {
    if (!gallery || navigator.connection?.saveData) return;
    const list = photos(gallery), img = gallery.querySelector('img');
    if (list.length < 2 || !img) return;
    const index = Math.max(0, list.findIndex(item => imageKey(item.dataset.src) === imageKey(img.src)));
    for (const offset of [1, -1, 2]) {
      const next = list[(index + offset + list.length) % list.length];
      if (imageKey(next.dataset.src) !== imageKey(img.src)) prepareImage(next.dataset.src).catch(() => {});
    }
  }
  for (const eventName of ['pointerover', 'focusin', 'touchstart']) {
    document.addEventListener(eventName, event => {
      warm(event.target.closest('milanis-catalog [data-gallery]'));
    }, { passive: true });
  }
  function imageKey(source) {
    try { const url = new URL(source, location.href); return url.origin + url.pathname; }
    catch { return source; }
  }
  async function step(gallery, direction) {
    const list = photos(gallery), img = gallery.querySelector('img');
    if (list.length < 2 || !img) return;
    let state = galleries.get(gallery);
    if (!state) { state = { busy: false, queue: [] }; galleries.set(gallery, state); }
    if (state.busy) { if (state.queue.length < 5) state.queue.push(direction); return; }
    state.busy = true;
    let overlay;
    try {
      let index = list.findIndex(item => imageKey(item.dataset.src) === imageKey(img.src));
      if (index < 0) index = 0;
      const next = list[(index + direction + list.length) % list.length];
      const before = img.src;
      const loaded = (await prepareImage(next.dataset.src)).cloneNode();
      if (!gallery.isConnected || img.src !== before) return;
      overlay = loaded;
      overlay.alt = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'mvc__gallery-transition';
      const host = gallery.querySelector('.mvc__photo') || gallery;
      Object.assign(overlay.style, { position:'absolute', inset:'0', width:'100%', height:'100%', objectFit:'cover', pointerEvents:'none', zIndex:'0' });
      host.append(overlay);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        await overlay.animate([{opacity:0},{opacity:1}], {duration:140,easing:'ease-out',fill:'both'}).finished;
      }
      img.removeAttribute('srcset');
      img.src = next.dataset.src;
      img.alt = next.dataset.alt || '';
      await img.decode().catch(() => {});
      warm(gallery);
    } catch {
      // Keep the current photo if the next image cannot be loaded.
    } finally {
      overlay?.remove();
      state.busy = false;
      if (state.queue.length && gallery.isConnected) step(gallery, state.queue.shift());
    }
  }
  function variant(form) {
    const option = form.querySelector('select').selectedOptions[0];
    const content = form.closest('[data-quick-content]');
    content.querySelector('[data-quick-price]').textContent = option.dataset.price;
    const quantity = Number(option.dataset.min) || 1;
    form.elements.quantity.value = quantity;
    const note = form.querySelector('[data-quantity-note]');
    note.hidden = quantity === 1;
    note.textContent = `Quantity: ${quantity}`;
    const button = form.querySelector('[type="submit"]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
    const img = content.querySelector('.mvcq__gallery img');
    if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
  }
  async function open(button) {
    const catalog = button.closest('milanis-catalog');
    const dialog = catalog.querySelector('dialog');
    if (activeDialog?.open) return;
    opener = button;
    activeDialog = dialog;
    const body = dialog.querySelector('.mvc__dialog-body');
    body.innerHTML = '<p class="mvc__loading" role="status">Loading…</p>';
    scrollBefore = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('.mvc__close').focus();
    request?.abort();
    const pending = new AbortController();
    request = pending;
    dialog.addEventListener('close', () => {
      pending.abort();
      document.documentElement.style.overflow = scrollBefore;
      activeDialog = null;
      if (opener?.isConnected) opener.focus();
    }, { once: true });
    try {
      const url = new URL(button.dataset.quickUrl, location.origin);
      url.searchParams.set('section_id', 'milanis-quick-view');
      const response = await fetch(url, { signal: pending.signal });
      if (!response.ok) throw new Error('Could not load product');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-quick-content]');
      if (!content) throw new Error('Quick view section is missing');
      if (!dialog.open || pending.signal.aborted) return;
      body.replaceChildren(content);
      const form = body.querySelector('[data-quick-form]');
      if (form) variant(form);
      warm(body.querySelector('[data-gallery]'));
    } catch (error) {
      if (error.name === 'AbortError') return;
      body.innerHTML = '<p class="mvc__loading">Unable to load quick view. <a>Open product</a></p>';
      body.querySelector('a').href = button.dataset.quickUrl;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (button?.closest('milanis-catalog')) {
      if (button.matches('[data-step]')) step(button.closest('[data-gallery]'), Number(button.dataset.step));
      if (button.matches('[data-quick-url]')) open(button);
      if (button.matches('.mvc__close')) button.closest('dialog').close();
    }
    if (event.target === activeDialog) {
      const box = activeDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) activeDialog.close();
    }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-quick-form]');
    if (form && event.target.matches('select')) {
      variant(form);
      form.querySelector('[data-quick-status]').textContent = '';
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-quick-form]')) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    form.dataset.busy = 'true';
    const button = form.querySelector('[type="submit"]');
    const select = form.querySelector('select');
    const payload = new FormData(form);
    button.disabled = true; select.disabled = true;
    const status = form.querySelector('[data-quick-status]');
    status.textContent = 'Adding…';
    try {
      const response = await fetch(`${form.action}.js`, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item.');
      status.textContent = 'Added to your cart.';
      form.querySelector('.mvcq__cart').hidden = false;
      document.dispatchEvent(new CustomEvent('milanis:cart-added', { detail: result }));
    } catch (error) {
      status.textContent = error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message;
    } finally {
      delete form.dataset.busy;
      select.disabled = false;
      variant(form);
    }
  });
  let touch;
  document.addEventListener('touchstart', event => {
    const gallery = event.target.closest('milanis-catalog [data-gallery]');
    touch = gallery && !event.target.closest('button') ? { gallery, x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', event => {
    if (!touch) return;
    const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      step(touch.gallery, dx < 0 ? 1 : -1);
      const gallery = touch.gallery;
      const suppress = e => { e.preventDefault(); e.stopPropagation(); };
      gallery.addEventListener('click', suppress, { capture: true, once: true });
      setTimeout(() => gallery.removeEventListener('click', suppress, true), 400);
    }
    touch = null;
  }, { passive: true });
  document.addEventListener('shopify:section:load', event => enable(event.target));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches('milanis-catalog, .mvc__card') || node.querySelector('milanis-catalog, .mvc__card'))) enable(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', event => { if (activeDialog && event.target.contains(activeDialog)) activeDialog.close(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enable());
  else enable();
})();
